/* import __COLOCATED_TEMPLATE__ from './restricted-view-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    reason: string;
    learnMoreUrl?: string;
  };
  Element: HTMLElement;
}

const RestrictedViewTooltip = templateOnlyComponent<Signature>();
export default RestrictedViewTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::RestrictedViewTooltip': typeof RestrictedViewTooltip;
    'reporting/restricted-view-tooltip': typeof RestrictedViewTooltip;
  }
}
